import { Visit, WebPortalClient, StudyScheduleSession } from "webportalclient";

export const ConfigureDiaryDeployments = async (client: WebPortalClient, subjectId: string, sessionScheduleItems: StudyScheduleSession[], serialNumber: string) => {

    const uniqueVisitScheduleItemIds = [...new Set(sessionScheduleItems.map(ssi => ssi.studyScheduleVisitId))];

    const currentDiaryPackageDeployments = await client.getDiaryPackageDeployments(undefined, `serialNumber eq '${serialNumber}'`);
    for (const deployment of currentDiaryPackageDeployments.value) {
        await client.deleteDiaryPackageDeployment(deployment.id);
    }

    let visit: Visit;
    for (const sessionScheduleItem of sessionScheduleItems) {
        const visitsResult = await client.getVisits(undefined, `subjectId eq ${subjectId} and (${uniqueVisitScheduleItemIds.map(vsi => `visitScheduleItemId eq ${vsi}`).join(" or ")})`);
        if (visitsResult.value.length > 0 && visitsResult.value.map(vq => vq.visitScheduleItemId).includes(sessionScheduleItem.studyScheduleVisitId)) {
            visit = visitsResult.value.find(vq => vq.visitScheduleItemId === sessionScheduleItem.studyScheduleVisitId);
        }
        else {
            const visitScheduleResult = await client.getStudyScheduleVisit(sessionScheduleItem.studyScheduleVisitId);
            visit = await client.postVisit({ subjectId: subjectId, name: visitScheduleResult.label });
        }

        await client.postDiaryPackageDeployment({ subjectId: subjectId, visitId: visit.id, sessionScheduleId: sessionScheduleItem.id, serialNumber: serialNumber });
    }
}
